import { hasPersonalContactDetails, hasSSN } from '@zg-rentals/satellite-components';

export type SendWarningType = 'personal-contact' | 'ssn';

/**
 * Decides whether sending a message should be interrupted by the
 * `PersonalContactDetailsWarningModal`, and which warning variant the caller
 * should render.
 *
 * Returns `null` when the message has no detected PII and can be sent
 * immediately. Otherwise returns a tag the caller maps to the actual
 * `warningData` at render time — the helper deliberately does not resolve
 * the data itself so that server-driven copy (e.g. `personalContactWarningData`
 * from `useUserWarnings()`) stays reactive after the modal opens.
 *
 * SSN takes precedence over email/phone because it is the more sensitive
 * disclosure — if a message contains both, the user is warned about the
 * SSN first.
 */
export const getSendWarning = (messageText: string): SendWarningType | null => {
  if (hasSSN(messageText)) {
    return 'ssn';
  }
  if (hasPersonalContactDetails(messageText)) {
    return 'personal-contact';
  }
  return null;
};
